import { Box, Paper } from "@mui/material";
import React, { useEffect } from "react";
import SharepointTab from "./SharepointTab";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import { useParams } from "react-router-dom";
import ChangeOrder from "./ChangeOrder";
import DocumentTransmittalTab from "./DocumentTransmittalTab";
import DocReviewer from "./DocReviewer";
import { useDCS } from "./Table/DCSContext";
import TasksTabWrapper from "./Tasks/TasksTabWrapper";
import PlantTasksWrapper from "../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
import ProjectTasksPage from "../../../Project/allProjectsPage/ProjectsTable/ProjectTasksPage";


const DCSTab = ({ plant = false }) => {
  const { projectId } = useParams();
  const { documentList, getAllList } = useDCS();
  useEffect(() => {
    getAllList();
  }, [getAllList]);

  // console.log({ projectId });
  const tabs = [
    {
      label: "Sharepoint ",
      panel: <SharepointTab plant={plant} />,
    },
    // {
    //   label: "MRQ",
    //   panel: <DCSTable projectId={projectId || ""} type="MRQ" />,
    // },
    {
      label: "Doc. Reviewer",
      panel: <DocReviewer projectId={projectId} plant={plant} />,
    },
    {
      label: "4D Schedule",
      panel: plant ? (
        <PlantTasksWrapper type={"engineering"} />
      ) : (
        <ProjectTasksPage catList={documentList} plant={plant} />
      ),
    },
    // {
    //   label: "Doc. Transmittal",
    //   panel: (
    //     <DocumentTransmittalTab
    //       projectId={projectId || ""}
    //       type="Doc. Transmittal"
    //     />
    //   ),
    // },
    // {
    //   label: "RFI",
    //   panel: <DCSTable type="RFI" />,
    // },
    // {
    //   label: "Change Order",
    //   panel: <ChangeOrder type="Change Order" />,
    // },
    // {
    //   label: "Transmittal",
    //   panel: <DocumentTransmittalTab />,
    // },
  ];

  return (
    <Paper sx={{ width: "100%", display: "flex" }}>
      <NavTabs tabs={tabs} navLabel="dcs-tab" />
    </Paper>
  );
};

export default DCSTab;
